<template>
    <div>
        <div class="inline-form-group">
            <el-form-item label="Tryb kafelków"
                          :error="errors['tiles_mode']">
                <el-switch v-model="form.tiles_mode"></el-switch>
            </el-form-item>
            <el-form-item label="Tryb kalendarza"
                          :error="errors['calendar_mode']">
                <el-switch v-model="form.calendar_mode"></el-switch>
            </el-form-item>
        </div>
        <el-collapse class="formset__list">
            <div v-for="section, i in form.sections" class="formset__item">
                <el-collapse-item :name="i">
                    <template slot="title">
                        <formset-header :label="`${section.name_pl || 'Nowa sekcja'}`"
                                        :items.sync="form.sections"
                                        :errors="checkForErrors(errors.sections, [i])"
                                        :index="i"/>
                    </template>
                    <el-form-item label="Tytuł sekcji"
                                  :error="errors.sections && errors.sections[i] && errors.sections[i][addLanguageSuffix('name')]">
                        <el-input v-model="section[addLanguageSuffix('name')]"/>
                    </el-form-item>
                    <div class="inline-form-group">
                        <el-form-item label="Kolor tła"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['bg_color']">
                            <el-color-picker v-model="section.bg_color"></el-color-picker>
                        </el-form-item>
                        <el-form-item label="Wyświetlaj w kafelkach"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['show_in_tiles']">
                            <el-switch v-model="section.show_in_tiles"></el-switch>
                        </el-form-item>
                        <el-form-item label="Wyświetlaj w kalendarzu"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['show_in_calendar']">
                            <el-switch v-model="section.show_in_calendar"></el-switch>
                        </el-form-item>
                    </div>
                    <div class="inline-form-group">
                        <el-form-item label="Typ wydarzeń"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['event_type']">
                            <el-select class="fluid"
                                       @change="resetTags(section)"
                                       filterable
                                       v-model="section.event_type"
                                       placeholder="Typ wydarzenia">
                                <el-option
                                        v-for="item in availableTypes"
                                        :key="item"
                                        :label="translateType(item)"
                                        :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Tagi"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['tags']">
                            <el-select class="fluid"
                                       filterable
                                       multiple
                                       v-model="section.tags"
                                       :disabled="!(!!section.event_type)"
                                       placeholder="Wybierz tagi">
                                <el-option
                                        v-for="item in tagsForType(section.event_type)"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-collapse-item>
            </div>
        </el-collapse>
        <el-button @click="addSection"
                   type="primary"
                   class="fluid">
            Dodaj sekcję
        </el-button>
    </div>
</template>
<script>
    import draggable from 'vuedraggable'
    import {Tag} from '@/api'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                availableTags: {},  // grouped by labels
                availableTypes: []
            }
        },
        components: {
            draggable
        },
        mounted () {
            Tag.availableTags().then(response => {
                this.availableTypes = response.data.map(type => type.label)
                const dictionary = {}
                response.data.forEach(type => {
                    dictionary[type.label] = type.options
                })
                this.availableTags = dictionary
            })
        },
        methods: {
            translateType (type) {
                const translations = {
                    "music": "Koncerty",
                    "cinema": "Kino",
                    "theater": "Teatr",
                    "others": "Miasteczko"
                }
                return translations[type] || type
            },
            resetTags (section) {
                section.tags = []
            },
            tagsForType (type) {
                if (!type) return []
                return this.availableTags[type]
            },
            addSection () {
                const blankObject = {}
                if (!Array.isArray(this.form.sections)) {
                    this.$emit('update:form', {
                        ...this.form,
                        sections: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.sections.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .section {
        background: #f9f9f9;
        padding: 30px 0;
        border: 1px solid #e2e2e2;
        position: relative;
        margin-bottom: 20px;
        cursor: pointer;
        &__remove-button {
            position: absolute;
            cursor: pointer;
            z-index: 1;
            top: 0;
            border-radius: 50%;
            padding: 8px 10px;
            right: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// LineupWidget.vue?270982a6